import React from "react";

function ProductCard({ accent, product }) {
  const accentClasses = {
    orange: "border-orange-400 text-orange-500",
    blue: "border-sky-400 text-sky-500",
    green: "border-emerald-400 text-emerald-500",
    purple: "border-purple-400 text-purple-500",
  };

  const accentClass = accentClasses[accent || "orange"];

  return (
    <div className="flex flex-col rounded-2xl border border-slate-200 bg-white shadow-sm hover:shadow-md transition-shadow">
      <div className="flex-1 p-4">
        <div className="flex items-center justify-center rounded-xl bg-slate-100 h-28 mb-4">
        {product?.images?.[0] ? (
  <img
    src={product.images[0]}
    alt={product.title}
    className="h-full object-contain"
  />
) : (
  <span className="text-xs text-slate-400">No Image</span>
)}
        </div>
        <p className="text-sm font-semibold text-slate-900">
          {product?.title || product?.sku}
        </p>

        <p className="text-[11px] text-slate-400">
          {product?.packsize}
        </p>

        <p className="text-sm font-bold text-slate-900 mt-1">
          £{product?.price}
        </p>
      </div>

      <div className="px-4 pb-4">
        <button
          className={`w-full rounded-full border text-xs font-semibold py-2.5 ${accentClass}`}
        >
          Add +
        </button>
      </div>
    </div>
  );
}

export default ProductCard;